import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { createTRPCClient, httpLink, TRPCClientError } from '@trpc/client'
import { createTRPCOptionsProxy } from '@trpc/tanstack-react-query'
import superjson from 'superjson'
import type { TRPCRouter } from '@/trpc/router.ts'

export const trpcClient = createTRPCClient<TRPCRouter>({
  links: [
    httpLink({
      methodOverride: 'POST',
      transformer: superjson,
      url: '/api/trpc',
      fetch(url, options) {
        return fetch(url, { ...options, credentials: 'include' })
      }
    })
  ]
})

export function createAppRouterContext() {
  const refreshAuthorization = (error: unknown) => {
    if (error instanceof TRPCClientError && ['FORBIDDEN', 'UNAUTHORIZED'].includes(error.data?.code)) {
      void queryClient.invalidateQueries(trpc.auth.session.queryFilter())
    }
  }
  const queryClient = new QueryClient({
    queryCache: new QueryCache({ onError: refreshAuthorization }),
    mutationCache: new MutationCache({ onError: refreshAuthorization }),
    defaultOptions: {
      dehydrate: { serializeData: superjson.serialize },
      hydrate: { deserializeData: superjson.deserialize }
    }
  })

  const trpc = createTRPCOptionsProxy({
    client: trpcClient,
    queryClient
  })

  return { queryClient, trpc }
}

export type AppRouterContext = ReturnType<typeof createAppRouterContext>

export { AUTH_SESSION_STALE_TIME } from '@/const/auth.ts'
